export const BANK_OPTIONS = [
  { value: 'anchor', label: 'Anchor' },
  { value: 'novo_saque', label: 'Novo Saque' },
  { value: 'bank321', label: '321Bank' },
  { value: 'c6', label: 'C6' },
  { value: 'handplus', label: 'Hand+' },
  { value: 'facta', label: 'Facta' },
  { value: 'presenca_bank', label: 'Presença Bank' },
  { value: 'v8', label: 'V8' },
  { value: 'soma', label: 'Soma' },
  { value: 'bull', label: 'Bull' },
  { value: 'neon', label: 'Neon' },
  { value: 'bmg', label: 'Banco BMG' },
  { value: 'fintech_corban', label: 'Fintech do Corban' },
];

export const BANK_CARD_META = {
  anchor: {
    isNew: true,
    title: 'Anchor',
    subtitle: 'Crédito consignado CLT · Autorização pelo banco',
    beta: true,
  },
  novo_saque: {
    isNew: true,
    title: 'Novo Saque',
    subtitle: 'CLT e FGTS · Cadastro de credenciais',
    beta: true,
  },
  bank321: {
    isNew: true,
    title: '321Bank',
    subtitle: 'Crédito consignado para trabalhadores CLT',
    beta: true,
  },
  c6: {
    title: 'C6 Bank',
    subtitle: 'Crédito consignado para trabalhadores CLT',
  },
  handplus: {
    title: 'Hand+',
    subtitle: 'Consignado CLT e antecipação do FGTS',
  },
  facta: {
    title: 'Facta',
    subtitle: 'Consignado CLT e antecipação do FGTS',
  },
  presenca_bank: {
    title: 'Presença Bank',
    subtitle: 'Crédito consignado para trabalhadores CLT',
  },
  v8: {
    title: 'V8',
    subtitle: 'Consignado CLT e antecipação do FGTS',
  },
  soma: {
    title: 'Soma',
    subtitle: 'Crédito consignado para trabalhadores CLT',
  },
  bull: {
    title: 'Bull',
    subtitle: 'Crédito consignado para trabalhadores CLT',
    beta: true,
  },
  neon: {
    title: 'Neon',
    subtitle: 'Crédito consignado para trabalhadores CLT',
    beta: true,
  },
  bmg: {
    title: 'Banco BMG',
    subtitle: 'Crédito consignado para trabalhadores CLT',
  },
  fintech_corban: {
    title: 'Fintech do Corban',
    subtitle: 'Crédito consignado para trabalhadores CLT',
  },
};
